<template>
  <div class="modal-mask" @click.self="closeAddBaseRefPopup">
    <div
      class="addBaseRefPopup"
      :style="{ left: location.x + 'px', top: location.y + 'px' }"
    >
      <p>{{ $t("result.toevoegen_aan") }}</p>
      <div class="button-group">
        <button
          @click="
            addToGroup({
              group: 'baseGroup',
              filterName: pageName,
              tagName: item.title,
              variable: item.variable,
            })
          "
        >
          <span>{{ $t("result.basisselectie") }}</span>
          <img
            :class="[activeClassBase(pageName, item)]"
            src="../assets/Icons/check.svg"
          />
        </button>
        <button
          @click="
            addToGroup({
              group: 'referenceGroup',
              filterName: pageName,
              tagName: item.title,
              variable: item.variable,
            })
          "
        >
          <span>{{ $t("result.referentieselectie") }}</span>
          <img
            :class="[activeClassRef(pageName, item)]"
            src="../assets/Icons/check.svg"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapState, mapActions, mapMutations } from "vuex";
// import { activeClass } from "@/mixins/activeClass.js";
// export default {
//   mixins: [activeClass],
//   props: {
//     location: Object,
//     item: Object,
//   },
//   data() {
//     return {
//       pageName: this.$route.path.substring(
//         this.$route.path.lastIndexOf("/") + 1
//       ),
//       xCoords: null,
//       yCoords: null,
//     };
//   },
//   methods: {
//     ...mapActions("baseRef", ["addToGroup", "removeFromGroup"]),
//     ...mapMutations("addBaseRefPopup", ["closeAddBaseRefPopup"]),
//   },
//   computed: {
//     ...mapState("baseRef", ["baseGroup", "referenceGroup"]),
//   },
// };

import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { activeClass } from "@/mixins/activeClass.js";

export default {
  mixins: [activeClass],
  props: {
    location: Object,
    item: Object,
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();

    // Reactive data
    const pageName = ref(route.path.substring(route.path.lastIndexOf("/") + 1));
    const xCoords = ref(null);
    const yCoords = ref(null);

    // Vuex actions and mutations
    const addToGroup = (group) => {
      store.dispatch("baseRef/addToGroup", group);
    };

    const removeFromGroup = (group) => {
      store.dispatch("baseRef/removeFromGroup", group);
    };

    const closeAddBaseRefPopup = () => {
      store.commit("addBaseRefPopup/closeAddBaseRefPopup");
    };

    // Computed properties
    const baseGroup = computed(() => store.state.baseRef.baseGroup);
    const referenceGroup = computed(() => store.state.baseRef.referenceGroup);

    // Optional: Lifecycle hook if needed
    onMounted(() => {
      // Perform any additional setup actions here
    });

    // Return all variables and methods to expose them to the template
    return {
      pageName,
      xCoords,
      yCoords,
      addToGroup,
      removeFromGroup,
      closeAddBaseRefPopup,
      baseGroup,
      referenceGroup,
    };
  },
};
</script>

<style lang="sass" scoped>
.baseGroup
  display: flex !important
.refGroup
  display: flex !important
.modal-mask
  position: fixed
  z-index: 10003
  top: 0
  left: 0
  right: 0
  bottom: 0
  .addBaseRefPopup
    position: absolute
    top: 113px
    left: 80px
    background-color: #0F1213
    padding: 17px 21px 18px 14px
    border-radius: 10px
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5)
    box-sizing: border-box
    z-index: 9995
    p
      margin: 0
      font-size: 13px
      line-height: 14px
      margin-bottom: 16px
    .button-group
      display: flex
      flex-direction: column
      button
        display: flex
        flex-direction: row
        justify-content: center
        align-items: center
        border-radius: 22.5px
        color: $white
        border: none
        font-size: 15px
        line-height: 20px
        text-align: center
        height: 40px
        width: 185px
        transition: background-color 300ms ease
        &:first-child
          background-color: $red
          margin-bottom: 10px
          &:hover
            background-color: #CA3233
        &:last-child
          background-color: $blue
          &:hover
            background-color: #00366A
        img
          display: none
          height: 20px
</style>
